import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import AddLead from "./addLead.js";
import ImportLead from "./importLead";
import { secretKey } from "./data";
import { downloadExcel } from "react-export-table-to-excel";

const MySwal = withReactContent(Swal2);

const LeadQue = (props) => {
  const [loading, setLoading] = useState(true);
  const [showAddLead, setShowAddLead] = useState(false);
  const [showImportLead, setShowImportLead] = useState(false);
  const [leads, setLeads] = useState([]);
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);

  const closeAddLead = () => {
    setShowAddLead(false);
    getData();
  };

  const closeImportLead = () => {
    setShowImportLead(false);
    getData();
  };

  const createExcelDS = () => {
    var tab = [];
    leads.map((el) => {
      tab.push([
        el.id,
        el.name,
        el.phone,
        el.mail,
        el.status,
        el.source,
        el.sourceNote,
        el.date,
        el.statusNote,
        el.company,
        el.idSource,
      ]);
    });
    return tab;
  };

  const exportToExcel = (e) => {
    var header = [
      "ID",
      "Imię i nazwisko",
      "Numer telefonu",
      "Adres e-mail",
      "Status",
      "Źródło",
      "Notatka - źródło",
      "Data pozyskania",
      "Notatka",
      "Dział",
      "ID źródło",
    ];
    downloadExcel({
      fileName: "leads_report_" + new Date(),
      sheet: "data",
      tablePayload: {
        header,
        body: createExcelDS(),
      },
    });
  };

  const fetchLeadsQue = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getLeadsQueData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeads(data.filter((e) => +e.dist !== 1));
        fetchUsers();
      })
      .catch((error) => {});
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getUsersList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchCompanies();
      })
      .catch((error) => {});
  };

  const fetchCompanies = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getCompanies", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setCompanies(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchDeleteLead = async (id) => {
    var body = { id: id };

    await fetch("https://apisplit.ftpeople.pl/deleteLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "lead",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const fetchSplitLeads = async (id) => {
    setLoading(true);
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/split", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        setTimeout(function () {
          MySwal.fire({
            icon: "success",
            title: "Rozdzielono",
            text: "leady",
          }).then(async (result) => {
            getData();
          });
        }, 5000);
      })
      .catch((error) => {});
  };

  const fetchSplitLeadsAll = async (id) => {
    setLoading(true);
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/splitAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        setTimeout(function () {
          MySwal.fire({
            icon: "success",
            title: "Rozdzielono",
            text: "wszystkie leady",
          }).then(async (result) => {
            getData();
          });
        }, 5000);
      })
      .catch((error) => {});
  };

  const fetchEditLead = async (id, field, value) => {
    var body = { id: id, field: field, value: value };

    await fetch("https://apisplit.ftpeople.pl/editLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "lead",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchLeadsQue();
  };

  useEffect(() => {
    getData();
  }, []);

  const fetchDeleteAllLeadsQue = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/deleteAllLeadsQue", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Wyczyszczono",
          text: "kolejkę",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const deleteAllQue = () => {
    fetchDeleteAllLeadsQue();
  };

  const deleteLead = (e) => {
    var id = e.target.value;
    fetchDeleteLead(id);
  };

  const editLead = (e) => {
    var id = e.target.value;
    var field = e.target.id;

    MySwal.fire({
      title: "Zmiana",
      input: "text",
      inputLabel: "nowa wartość",
      cancelButtonText: "Anuluj",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "Wpisz numer telefonu";
        } else {
          fetchEditLead(id, field, value);
        }
      },
    });
  };

  const editLeadAss = (e) => {
    var id = e.target.value;
    var field = e.target.id;

    var model = [];
    users
      .filter((el) => el.companies.trim() === props.user.companies.trim())
      .map((user) => {
        model[user.id] = user.name;
      });

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        fetchEditLead(id, field, result.value);
      }
    });
  };

  const leadsData = (
    <>
      <p
        style={{
          textAlign: "left",
          margin: "0",
          fontSize: ".8vw",
          marginTop: "2vh",
        }}
      >
        Liczba kontaktów: {leads.length}
      </p>
      <table style={{ marginTop: "0vh" }} className="clients_table">
        <tr key={0}>
          <th>id</th>
          <th>nazwa</th>
          <th>numer telefonu</th>
          <th>adres e-mail</th>
          <th>źródło</th>
          <th>ID źródło</th>
          <th>data pozyskania</th>
          <th>uwagi - źródło</th>
          <th>dział</th>
          <th>akcja</th>
        </tr>
        {leads
          .sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          })
          .map((el, index) => (
            <>
              <tr id={""} key={el.id}>
                <td>{el.id}</td>
                <td>{el.name}</td>
                <td>{el.phone}</td>
                <td>{el.mail}</td>
                <td>{el.source}</td>
                <td>{el.idSource}</td>
                <td>
                  {new Date(el.date).getFullYear() +
                    "-" +
                    (new Date(el.date).getMonth() + 1 < 10
                      ? "0" + (new Date(el.date).getMonth() + 1)
                      : new Date(el.date).getMonth() + 1) +
                    "-" +
                    (new Date(el.date).getDate() < 10
                      ? "0" + new Date(el.date).getDate()
                      : new Date(el.date).getDate())}
                </td>
                <td
                  style={{
                    width: "20%",
                    lineBreak: "anywhere",
                    paddiing: "5px",
                  }}
                >
                  {el.sourceNote}
                </td>
                <td>{el.company}</td>
                <td
                  style={{ width: "20%", minWidth: "200px", lineBreak: "none" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "5px",
                      padding: "10px 0px",
                    }}
                  >
                    <button
                      className="loginButtonLogin"
                      value={el.id}
                      style={{
                        margin: "0",
                        backgroundColor: "navy",
                        borderColor: "navy",
                        width: "45%",
                        fontSize: ".6vw",
                      }}
                      onClick={deleteLead}
                    >
                      usuń
                    </button>
                    <button
                      className="loginButtonLogin"
                      id={"phone"}
                      value={el.id}
                      style={{
                        margin: "0",
                        backgroundColor: "navy",
                        borderColor: "navy",
                        width: "45%",
                        fontSize: ".6vw",
                      }}
                      onClick={editLead}
                    >
                      tel.
                    </button>
                    <button
                      className="loginButtonLogin"
                      id={"mail"}
                      value={el.id}
                      style={{
                        margin: "0",
                        backgroundColor: "navy",
                        borderColor: "navy",
                        width: "45%",
                        fontSize: ".6vw",
                      }}
                      onClick={editLead}
                    >
                      mail
                    </button>
                    <button
                      className="loginButtonLogin"
                      id={"seller"}
                      value={el.id}
                      style={{
                        margin: "0",
                        backgroundColor: "navy",
                        borderColor: "navy",
                        width: "45%",
                        fontSize: ".6vw",
                      }}
                      onClick={editLeadAss}
                    >
                      przypisz
                    </button>
                  </div>
                </td>
              </tr>
            </>
          ))}
      </table>
    </>
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div
            style={{
              paddingBottom: "3vh",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                gap: "1vw",
                alignItems: "self-end",
                position: "sticky",
                flexWrap: "wrap",
                top: "0",
                zIndex: "1",
                padding: "5px 5px",
                backgroundColor: "white",
                paddingLeft: "1vw",
                width: "100%",
                paddingBottom: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "self-end",
                  justifyContent: "left",
                  gap: "1vw",
                }}
              >
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "green",
                    borderColor: "green",
                    width: "180px",
                    height: "3vh",
                  }}
                  onClick={getData}
                >
                  ODŚWIEŻ
                </button>
                {props.user.role === "admin" ? (
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "blue",
                      borderColor: "blue",
                      width: "180px",
                      height: "3vh",
                    }}
                    onClick={exportToExcel}
                  >
                    EKSPORT DO EXCEL
                  </button>
                ) : (
                  ""
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "left",
                  gap: "1vw",
                  marginTop: "2vh",
                }}
              >
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{ margin: "0", width: "180px" }}
                  onClick={() => setShowImportLead(true)}
                >
                  IMPORT LEADÓW
                </button>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "180px",
                  }}
                  onClick={fetchSplitLeads}
                >
                  ROZDZIEL LEADY
                </button>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "180px",
                  }}
                  onClick={fetchSplitLeadsAll}
                >
                  ROZDZIEL LEADY - WSZYSTKIE
                </button>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "gray",
                    borderColor: "gray",
                    width: "180px",
                  }}
                  onClick={() => setShowAddLead(true)}
                >
                  DODAJ LEAD
                </button>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "red",
                    borderColor: "red",
                    width: "180px",
                  }}
                  onClick={deleteAllQue}
                >
                  USUŃ WSZYSTKIE
                </button>
              </div>
            </div>
            <div style={{ paddingLeft: "1vw" }}>{leadsData}</div>
          </div>

          {showAddLead ? (
            <>
              <AddLead close={closeAddLead} companies={companies} />
            </>
          ) : (
            ""
          )}
          {showImportLead ? (
            <>
              <ImportLead close={closeImportLead} companies={companies} />
            </>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default LeadQue;
